import { Common, color, device, utils } from '@stockbit/ui';
import styled, { css } from 'styled-components';
import Image from 'global/Image';
import { Mentions } from 'antd';

const { Flex, Iconmoon } = Common;
const { hexOpacity: percentToHex } = utils;

interface ComposeContentProps {
  isExpand?: boolean;
  isFooterExpanded?: boolean;
}

interface ImageUploadProps {
  isLongImage?: boolean;
}

const ReplyCompose = styled.div < ComposeContentProps > `
  position: fixed;
  bottom: 0;
  // TODO : Add Color to @stockbit/ui
  border-top: 1px solid #f1f1f1;
  background-color: ${color.light};
  width: 100%;
  
  .show-drag-area {
    border-style: dashed;
    border-width: 2px;
    border-color: ${color.primary};
  }

  @media ${device.tablet} {
    position: relative;
    top: unset !important;
  }

  ${({ isExpand }) => isExpand && css`
    top: 60px;
    bottom: 0px;
    form {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      
    }

    @media ${device.tablet} {
      form {
        height: auto;
        flex-direction: column;
        justify-content: flex-end;
      }
    }
  `}
`;

const TextareaMentions = styled(Mentions).attrs((props) => ({
  placeholder: props.placeholder || 'Write your comment here...',
  autoSize: props.autoSize || { minRows: 3 },
}))`
  border: none !important;
  box-shadow: none !important;
  font-family: 'ProximaNovaRg';
  margin-bottom: 12px;
  margin-top: 10px;
  resize: none;
  width: 100%;

  textarea {
    padding: 0;
  }

  :focus {
    outline: none;
  }
`;

const ComposeContent = styled.div < ComposeContentProps > `
  display: none;
  max-height: 200px;
  overflow: scroll;
  margin-left: 10px;

  @media ${device.tablet} {
    max-height: 340px;
  }

  ${({ isExpand }) =>
    isExpand &&
    css`
      display: block;
      flex: 1 0 90%;
      max-height: 600px;
    `}

  ${({ isFooterExpanded }) =>
    isFooterExpanded &&
    css`
      max-height: 200px;
    `}
`;

const FooterComposeWrapper = styled(Flex).attrs({
  align: 'center',
  justify: 'space-between',
  width: '100%',
})`
  position: fixed;
  bottom: 10px;    
  padding: 0 20px;

  @media ${device.tablet} {
    position: relative;
    bottom: unset;
    padding: 0px 20px 15px 20px;
  }
`;

const ImageContainer = styled(Flex)`
  justify-content: center;
  height: 200px;
  max-height: 200px;
  background: ${color.whisper};
  overflow: hidden;
  cursor: pointer;
`;

const ImageUpload = styled(Image) < ImageUploadProps > `
  width: initial;
  object-fit: cover;
  object-position: 50% 50%;
  height: 100%;

  ${({ isLongImage }) =>
    isLongImage &&
    css`
      width: 100%;
      height: auto;
      align-self: center;
    `}
`;

const IconCloseWrapper = styled.div`
  position: absolute;
  right: 8px;
  top: 8px;
  border-radius: 100%;
  background: ${color.highgray}${percentToHex(70)};
  padding: 5px;
  cursor: pointer;
`;

const IconClose = styled(Iconmoon)`
  font-size: 14px; 
  font-weight: bold;
  color: ${color.light};
  :hover {
    color: ${color.light};
  }
`;

const EmojiContainer = styled.div`
  position: fixed;
  bottom: 25px;
  width: 100%;
  border-top: 1px solid ${color.gainsboro};
  padding: 0;
  @media ${device.tablet} {
    position: relative;
    bottom: unset;
  }
`;

const GifContainer = styled.div`
  position: fixed;
  bottom: 25px;
  width: 100%;
  border-top: 1px solid ${color.gainsboro};
  padding: 20px 20px 10px 20px;
  @media ${device.tablet} {
    position: relative;
    bottom: unset;
    padding: 20px 20px 0px 20px;
  }
`;

const MentionSuggestionResult = styled.div`
  > div {
    .ant-mentions-dropdown {
      left: 70px !important;
    }
    .ant-mentions-dropdown-menu-item {
      border-bottom: 1px solid #f5f6f5;
      height: 30px;
      padding: 0 12px;

      & > div {
        height: 30px;
      }
    }
    .ant-mentions-dropdown-menu-item-active {
       p {
        font-family: var(--font-bold) !important;
      }
    }
    .ant-mentions-dropdown-menu-item-disabled {
      display: none;
    }
  }
`;

const AvatarContainer = styled.div`
  margin-right: 8px;
  > img {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 1px solid ${color.component};
    background: ${color.lowgray};
  }
`;

export {
  TextareaMentions,
  ComposeContent,
  ReplyCompose,
  FooterComposeWrapper,
  ImageContainer,
  ImageUpload,
  IconCloseWrapper,
  IconClose,
  EmojiContainer,
  GifContainer,
  MentionSuggestionResult,
  AvatarContainer,
};
